// extracted by mini-css-extract-plugin
export default {"tooltip":"coverage-tip-module__tooltip--jno"};